export const joinNames = (names: string[], language: string): string =>
  new Intl.ListFormat(language, { type: "conjunction" }).format(names)
